
import telcomCard from "./telcomCard";
import archiveDevice from "./archiveDevice";
import serviceCharge from  "./serviceCharge"


export default {
    telcomCard,archiveDevice,serviceCharge
}